import { Cabinet } from 'shared/interfaces';
import * as types from './types';
import { getArcadeId } from '../arcade/selectors';
import { 
    apiGetArcadeCabinets, 
    apiGetArcadeCabinet,
    apiCreateArcadeCabinet,
    apiUpdateArcadeCabinet,
    apiDeleteArcadeCabinet
} from './api';

// list
export const setArcadeCabinetList = list => ({ type: types.ARCADE_CABINETS__SET_CABINET_LIST, list });

// panel
export const setArcadeCabinet = cabinet => ({ type: types.ARCADE_CABINETS__SET_CABINET, cabinet });
export const resetCabinetEditor = () => ({ type: types.ARCADE_CABINETS__CLEAR_CABINET });
export const setArcadeCabinetValue = (name, value) => ({ type: types.ARCADE_CABINETS__SET_CABINET_VALUE, name, value });
export const selectRom = rom => ({ type: types.ARCADE_CABINETS__SELECT_ROM, rom });

// api
export const getArcadeCabinets = (arcadeId?: string) => async (dispatch, getState) => {
    arcadeId = arcadeId || getArcadeId(getState());
    if (!arcadeId) {
        throw new Error('No arcade is being edited');
    }
    const results = await apiGetArcadeCabinets(arcadeId);
    return await dispatch(setArcadeCabinetList(results?.cabinets ?? []));
};

/** Actually both grabs the cabinet and starts editing it **/
export const loadArcadeCabinetForEditing = (cabinetId: string) => async (dispatch) => {
    const arcadeGame = await apiGetArcadeCabinet(cabinetId);
    return await dispatch(setArcadeCabinet(arcadeGame));
};

export const createArcadeCabinet = (cabinet: Cabinet) => async (dispatch, getState) => {
    const arcadeId = getArcadeId(getState());
    const payload = {
        arcadeId,
        bannerImage: cabinet.bannerImage ?? undefined,
        image: cabinet.image ?? undefined,
        metaDataValues: cabinet.metaDataValues ?? undefined,
        romId: cabinet.romId,
    };
    await apiCreateArcadeCabinet(payload);
    return await dispatch(getArcadeCabinets(arcadeId));
};

export const updateArcadeCabinet = (cabinet: Cabinet) => async (dispatch, getState) => {
    const arcadeId = getArcadeId(getState());
    const payload = {
        bannerImage: cabinet.bannerImage ?? undefined,
        image: cabinet.image ?? undefined,
        metaDataValues: cabinet.metaDataValues ?? undefined,
        romId: cabinet.romId,
    };
    await apiUpdateArcadeCabinet(cabinet.cabinetId, payload);
    return await dispatch(getArcadeCabinets(arcadeId));
};

export const deleteArcadeCabinet = (cabinetId: string) => async (dispatch, getState) => {
    const arcadeId = getArcadeId(getState());
    await apiDeleteArcadeCabinet(cabinetId);
    return await dispatch(getArcadeCabinets(arcadeId));
};

